<script>
import EmployeeManagementEmailInput from './EmployeeManagementEmailInput.vue'
export default {
  components: {
    EmailInput: EmployeeManagementEmailInput
  },
  props: {
    selectedMethod: {
      type: String,
      default: 'email'
    }
  },
  data: () => ({
    loading: false,
    csvFile: null,
    validationResponse: null,
    hasError: false,
    validationRules: [
      value => {
        return !value || !value.length || value[0].size < 50000000
          || this.$t('component.profile.administrationManagement.csv.upload.validation.rule.error')
      }
    ]
  }),
  methods: {
    checkEmail() {
      let invitationForm = this.$refs.invitationForm
      let email = invitationForm.email

      invitationForm.$v.$touch()
      if (!invitationForm.$v.$invalid) {
        this.loading = true
        this.$organizationService
          .existsUser(email)
          .then(response => {
            // Email exists
            if (response) {
              this.validationResponse = response
              console.error('error checking email', response)

              this.$emit('set-validation-response', response)
              this.$emit('alert-error', response)
              this.$emit('checked-user-for-dupes', { exists: response, email: email })
            }
            // Email does not exist
            else {
              this.validationResponse = response
              this.$emit('set-validation-response', response)
              this.$emit('step-forward')
              setTimeout(() => {
                this.$emit('checked-user-for-dupes', { exists: response, email: email })
                this.$emit('finish-wizard')
                this.$emit('close-dialog')
              }, 1500)
            }

          })
          .catch((error) => {
            console.error('error checking email', error)
            this.$emit('alert-error', error)
          })
          .finally(() => {
            this.loading = false
            invitationForm.email = ''
            invitationForm.$v.$reset()
          })
      }
    },
    validateCSV() {
      this.loading = true

      let formData = new FormData()
      formData.append('file', this.csvFile)

      this.$emit('set-csv-file', this.csvFile)

      this.$organizationService
        .validateCSV(formData)
        .then(response => {
          this.$emit('set-validation-response', response.data)
          response.data ? this.validationResponse = response.data : this.alert.state = true
        })
        .catch((error) => {
          this.$emit('set-validation-response', error)
          this.$emit('alert-error', error)
        })
        .finally(() => {
          this.loading = false
          this.$emit('step-forward')
        })
    },
    downloadCSVTemplate() {
      this.loading = true

      this.$organizationService
        .downloadCSVTemplate()
        .then(response => {
          let base64String = response.data.bytes // -> base64 string
          let byteCharacters = atob(base64String)
          let byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          let byteArray = new Uint8Array(byteNumbers)
          const url = window.URL.createObjectURL(new Blob([byteArray]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'template.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.error('error downloading csv template', error)
          this.$emit('alert-error', error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<template>
  <v-stepper-content step="2">
    <v-card-text v-if="selectedMethod === 'email'">
      <v-row class="pb-0">
        <v-col class="pb-0">
          <EmailInput ref="invitationForm" class="pt-2" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-if="selectedMethod === 'csv'">
      <v-row class="container pt-0">
        <v-col>
          <v-file-input
            v-model="csvFile"
            show-size
            :rules="validationRules"
            accept="text/csv"
            :placeholder="$t('component.profile.administrationManagement.choose.csv')"
            prepend-icon="mdi-file"
            label="CSV-Upload"
          ></v-file-input>
          <small>{{ $t('component.profile.administrationManagement.template.download') }}
            <a @click.prevent="downloadCSVTemplate">{{ $t('global.here') }}</a>
          </small>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        id="wizard_close_button"
        color="secondary"
        class="white--text px-8 py-2"
        @click="$emit('step-back')">
        <span>
        {{ $t('button.back') }}
      </span></v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="selectedMethod === 'email'"
        id="em_invite_button"
        color="primary"
        :loading="loading"
        class="white--text px-8 py-2"
        @click="checkEmail"
      ><span>
        {{ $t('button.invite') }}
      </span>
      </v-btn>
      <v-btn
        v-if="selectedMethod === 'csv'"
        id="em_csv_check_button"
        :disabled="!csvFile"
        color="primary"
        :loading="loading"
        class="white--text px-8 py-2"
        @click="validateCSV"
      ><span>
        {{ $t('button.check') }}
      </span>
      </v-btn>
    </v-card-actions>
  </v-stepper-content>
</template>
